import React from 'react';
import { Grid, Typography, Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import koImg from '../assets/img/error.svg'
import { useContext } from '../context';

export const OctKo = () => {
  const { t } = useTranslation('payment');

  const context = useContext();
  React.useEffect(() => {
    context.reset();
  }, []);

  return (
    <Container>
      <Grid container justify='center' spacing={4}>
        <Grid item xs={12}>
          <Typography variant='h4' align='center'>
            {t('OCT_KO_TITLE')}
          </Typography>
        </Grid>
        <Grid item xs={12} container justify='center'>
          <img src={koImg} style={{ maxWidth: 200 }} />
        </Grid>
        <Grid item xs={12}>
          <Typography align='center'>
            {t('OCT_KO_SUBTITLE')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography align='center'>
            {t('OCT_KO_DESCRIPTION')}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}